module.exports = __webpack_public_path__ + "static/fonts/Fact-BoldItalic.f0dca43.woff2";